import { render, staticRenderFns } from "./notesSidebar.vue?vue&type=template&id=12423f3e&scoped=true"
import script from "./notesSidebar.vue?vue&type=script&lang=js"
export * from "./notesSidebar.vue?vue&type=script&lang=js"
import style0 from "./notesSidebar.vue?vue&type=style&index=0&id=12423f3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12423f3e",
  null
  
)

export default component.exports